import getFieldsFromSchemaPath from './getFieldsFromSchemaPath.js';
import getLeafFieldNamesFromStructure from './getLeafFieldNamesFromStructure.js';

const getGraphqlLeafFieldNames = (schema, path) => {
  return getLeafFieldNamesFromStructure(getFieldsFromSchemaPath(schema, path));
};

export default getGraphqlLeafFieldNames;
